'use strict';

import './lib/a11y';
import './lib/buttons';
import './lib/modal';
import './lib/accordion';
import './lib/ticker';
import './lib/forms';

/**
 * Initialize accordions on modal open - callback
 * @param {Object} config - an object with the current modal id and settings
 */
window.initModalAccordions = function(config) {
  if (config && config.id) {
    const activeModal = document.getElementById(config.id);

    if (activeModal) {
      const accordionPanels = activeModal.querySelectorAll('.accordion__text');
      accordionPanels.forEach((panel) => {
        panel.setAttribute('hidden', '');
      });
    }
  }
};
